<div class="vtr-page-{{pageCssClass}} vtr-page container-fluid page-content-bg">
	<div class="row vtr-page-header">
		<div class="col">
			<vtr-header-main
				[title]="title"
				[parentPath]="parentPath"
				[menuItems]="menuItems"
				[forwardLink]=""
				[textId]="textId"
				[back]="back"
				[backId]="backId"
				[hideBack]="hideBack"
				[isInnerBack]="isInnerBack"
				[hideTitle]="hideTitle"
				(innerBack)="onInnerBack()">
				<ng-content select="header-content"></ng-content>
			</vtr-header-main>
		</div>
	</div>
	<div class="row vtr-page-columns">
		<div class="vtr-page-column vtr-page-left-column"
		[ngClass]="leftColStyle ? leftColStyle : 'col-xl-8 col-lg-6'">
			<div [ngClass]="{'vtr-page-column-shift-up':shiftLeftUp}">
				<!-- add the select attribute to ng-content -->
				<ng-content select="left-content"></ng-content>
			</div>
		</div>
		<div class="vtr-page-column vtr-page-right-column"
		[ngClass]="rightColStyle ? rightColStyle : 'col-xl-4 col-lg-6'">
			<div [ngClass]="{'vtr-page-column-shift-up':shiftRightUp}">
				<!-- add the select attribute to ng-content -->
				<ng-content select="right-content"></ng-content>
			</div>
		</div>
	</div>
</div>
